import { EventPlatformEntry } from "@kaltura/mediaspace-shared-types";
import { WebcastStatus } from "@kaltura/mediaspace-shared-utils";
import { MailMenu } from "./mail-menu/MailMenu";
import { Config } from "@kaltura/mediaspace-shared-data-kms-config";
import { RsvpButton, RsvpStatus } from "@kaltura/mediaspace-shared-entry";
import { JoinNowButton } from "./action-section/JoinNowButton";
import { WatchButton } from "./action-section/WatchButton";

/**
 * get call-to-action button per given live-status
 */
export const getCallToAction = (
    status: WebcastStatus,
    entryId: string,
    entry: EventPlatformEntry,
    vodCallback: (entryId: string, entryName: string, categoryId?: number) => void,
    liveCallback: (entryId: string, entryName: string, categoryId?: number) => void,
    config: Config,
    disabledMode?: boolean,
    categoryId?: number,
    rsvpStatus?: RsvpStatus,
    onRsvpChange?: (status: RsvpStatus | undefined) => void,
    calendarEntriesToken?: string
) => {
    switch (status) {
        case WebcastStatus.past: {
            if (!entry.recordedEntryId) {
                return null;
            }

            return (
                <WatchButton
                    entryName={entry.name}
                    disabled={disabledMode}
                    onClick={() => vodCallback(entryId, entry.name, categoryId)}
                />
            );
        }
        case WebcastStatus.live: {
            return (
                <JoinNowButton
                    entryName={entry.name}
                    disabled={disabledMode}
                    onClick={() => liveCallback(entryId, entry.name, categoryId)}
                />
            );
        }
        case WebcastStatus.future: {
            return (
                <div>
                    {config.rsvp?.isCrossSite ? (
                        <RsvpButton
                            entry={entry}
                            size={"large"}
                            allowResendPostRsvp={config.application.isLoggedIn}
                            analyticsValue={{ location: "Session card" }}
                            isLoading={rsvpStatus === undefined}
                            initialStatus={rsvpStatus}
                            onChange={onRsvpChange}
                            onToggleClicked={() => onRsvpChange?.(undefined)}
                            calendarEntriesToken={calendarEntriesToken}
                        />
                    ) : (
                        <MailMenu
                            entryId={entryId}
                            categoryId={categoryId}
                            calendarEntriesToken={calendarEntriesToken}
                        />
                    )}
                </div>
            );
        }
        default:
            return null;
    }
};
